import { cn } from "../../../lib/utils";

export type RenderUnitBadgeProps = {
    main: string;
    sub?: string | null;
    sup?: string | null;
    template?: boolean;
    size?: "sm" | "md";
    className?: string;
};

export function RenderUnitBadge({
    main,
    sub,
    sup,
    template = false,
    size = "md",
    className,
}: RenderUnitBadgeProps) {
    const hasMarks = Boolean(sub || sup);

    return (
        <span
            className={cn(
                "inline-flex shrink-0 items-center justify-center rounded-md border bg-muted/30 font-semibold text-muted-foreground",
                template ? "border-dashed border-border bg-muted/20" : "border-border",
                size === "sm"
                    ? "h-5 min-w-5 px-1 text-[10px]"
                    : "h-7 min-w-7 px-1.5 text-[11px]",
                className,
            )}
            aria-hidden="true"
            data-render-unit-badge={main}
            data-render-unit-badge-sub={sub ?? undefined}
            data-render-unit-badge-sup={sup ?? undefined}
            data-render-unit-badge-template={template ? "true" : undefined}
        >
            <span>{main}</span>
            {hasMarks ? (
                <span
                    className={cn(
                        "ml-0.5 flex flex-col items-center justify-center leading-none",
                        size === "sm" ? "text-[7px]" : "text-[8px]",
                    )}
                >
                    {sup ? <span>{sup}</span> : null}
                    {sub ? <span>{sub}</span> : null}
                </span>
            ) : null}
        </span>
    );
}
